import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {ButtonVariantsEnum} from '../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {ButtonContent} from '../../../../../libs/shared/ui/src/components/buttons/buttonContent';
import {ChromelessButton} from '../../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {VisualSizesEnum} from '../../../../../libs/shared/ui/src/styles/commonStyles';
import {fontSizes} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {PaletteColorsEnum} from '../../../../../libs/shared/ui/src/styles/paletteModel';
import {CompanyModel} from '../../../../models/api/companyModel';

/*
 * Props.
 */

interface MentionEditorDropdownAddTeammateCardProps {
  onClick: Handler;
  company: CompanyModel;
}

/*
 * Style.
 */

const StyledWrapperDiv = styled.div`
  border-radius: 4px;
  padding: 0px 15px 1px 7px;
`;

const StyledChromelessButton = styled(ChromelessButton)`
  display: inline;
`;

const StyledDescriptionSpan = styled.span`
  letter-spacing: -0.154px;
  color: ${(p) => p.theme.greys.shade70};

  font-size: ${fontSizes.verySmall};
  padding-bottom: 2px;
  display: inline;
`;

const StyledButtonContent = styled(ButtonContent)`
  padding: 0 4px;
  border-radius: 4px;
  font-size: ${fontSizes.verySmall};
  display: inline;
`;

/*
 * Component.
 */

export const MentionEditorDropdownAddTeammateCard: FC<MentionEditorDropdownAddTeammateCardProps> = (
  props,
) => {
  const {onClick, company} = props;

  return (
    <StyledWrapperDiv>
      <StyledChromelessButton
        shouldPreventMouseDown
        onClick={onClick}
        interactionId="mention-editor-dropdown-addteammate-click"
      >
        <StyledButtonContent
          variant={ButtonVariantsEnum.LINK}
          size={VisualSizesEnum.SMALL}
          color={PaletteColorsEnum.BLUE}
        >
          <Trans id="mention-editor-dropdown-addteammate-button">Invite people to {company.name}</Trans>
        </StyledButtonContent>
      </StyledChromelessButton>
      <StyledDescriptionSpan>
        <Trans id="mention-editor-dropdown-addteammate-text">to @mention them</Trans>
      </StyledDescriptionSpan>
    </StyledWrapperDiv>
  );
};
